import { mapGetters } from 'vuex';
const main = {
    data: () => ({
        drawer: 'http://fuabprueba.aplicacionesmdy.com/public/assets/media/logos/logo-2.svg',
        group: 0,
        perfil: [
            { id: '1', descripcion: 'Administrador' },
            { id: '2', descripcion: 'Usuario' },
            { id: '3', descripcion: 'Invitado' }
        ],
        notify: [
        ],
        countNotify : 0,
        hasNotificationsVal: false,
        loadingFileDownload: false,
    }),
    computed: {
        ...mapGetters(['getMenuItems']),
        items() {
            return this.getMenuItems;
        },
        description() {
            const perfilEncontrado = this.perfil.find(p => p.id === this.$store.state.rol);
            return perfilEncontrado ? perfilEncontrado.descripcion : '';
        },
        limitedNotify() {
            return this.notify.slice(0, 3);
        },
        totalNotify() {
            this.countNotify = this.notify.length;
            return this.notify.length;
        },
        hasNotifications() {
            this.hasNotificationsVal = false;
            return this.totalNotify > 0;
        }
    },
    methods: {
        async manual(){
            this.loadingFileDownload = true;
            try {
                const response = await this.$axios.get('/reporte/descargaManual')
                window.open(response.data.path, '_blank');
            } catch (error) {
                this.$toast.warning('Archivo no encontrado');
                this.loadingFileDownload = false;
            } 
            this.loadingFileDownload = false;

        },
        async getNotifications(){
            var response = await this.$axios.get('/notify/' + this.$store.state.id);

            try {
                this.notify = [];
                response.data.forEach(elem => {
                    this.notify.unshift({ title: `Nueva Notificación de ${elem.emisor}`, subtitle: elem.mensaje });
                });
                this.countNotify = response.data.length;
                if(response.data.length > 0){
                    this.hasNotificationsVal = true;
                }

            } catch (error) {
            }
            // this.$toast.success(`Tiene una nueva notificacion`, {
            //     timeout: 1400,
            // });
        },
        toggleDarkMode() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        },
        async viewNotifications(){
            this.hasNotificationsVal = false;
            try {
                await this.$axios.get('/update/notify/' + this.$store.state.id);
                this.countNotify = 0;
            } catch (error) {
            }
        }
    },
    mounted() {
        this.getNotifications();
        this.$nextTick(function () {
            window.setInterval(() => {
                this.getNotifications();
            }, 60000 );
        });
    },
    beforeDestroy() {
        window.Echo.leaveChannel('notify');
    },

}
export default main 